module.exports = __webpack_public_path__ + "img/loading-pmc.55aa23ee.gif";